import { useTranslation } from "react-i18next";
import { useStructureContext } from "../../../context/StructureContext";
import { headerAccounting } from "../../../data/admin";
import { stdObject } from "../../../data/types/stdObject";
import StdTable from "./StdTable";
import { useMainContext } from "../../../context/MainContext";
import { useEffect } from "react";

export default function AccountingBox() {
  const { type, searchValues, section, findServiceData, printArea } =
    useStructureContext();
  const { customUpdate, handleMainData } = useMainContext();
  const { t } = useTranslation();

  useEffect(() => {
    if (
      "mainInfo" in customUpdate.current &&
      ["CAJ", "DIN"].includes(customUpdate.current.mainInfo)
    ) {
      if ("info" in customUpdate.current) {
        const searchDate = searchValues[section.id].FECICA;
        if (searchDate.value !== "") {
          const infoDate =
            customUpdate.current.info["FEC" + customUpdate.current.mainInfo];
          let updateAction = false;
          if (searchDate.value2 === "") {
            updateAction = infoDate.startsWith(searchDate.value);
          } else {
            const date = new Date(infoDate.replace(" ", "T"));
            const start = new Date(searchDate.value + "T00:00:00");
            const end = new Date(searchDate.value2 + "T23:59:59");
            updateAction = date >= start && date <= end;
          }
          if (updateAction) {
            findServiceData();
          }
        }
      }
      customUpdate.current = {};
    }
  }, [customUpdate.current]);

  return "CUEICA" in searchValues[section.id] ? (
    <div className="listBox">
      <StdTable
        type={type}
        style={{ width: "100%" }}
        header={headerAccounting}
        data={
          "results" in searchValues[section.id]
            ? searchValues[section.id].results
            : []
        }
        onDoubleClick={(data, index) =>
          handleMainData(
            { [`COD${data.MKEY}`]: data.CODCAJ, AREA: data.AREA },
            index,
            false,
          )
        }
        className="listTableRow"
      />
    </div>
  ) : (
    <></>
  );
}
